import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-grid-list',
  templateUrl: './grid-list.component.html',
  styleUrls: ['./grid-list.component.scss'],
  host: { '[class]': 'classes' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridListComponent {
  @Input() cols = 1;
  @Input() minColWidth = '';
  @Input() rowHeight: 'fit' | 'auto' | string = 'auto';
  @Input() gutterSize = '0px';

  get classes(): string {
    return 'grid-list';
  }

  get gridStyles(): Record<string, string> {
    return {
      'grid-template-columns': this.resolveColumns(),
      'grid-auto-rows': this.resolveRowHeight(),
      gap: this.gutterSize,
    };
  }

  private resolveColumns(): string {
    if (this.minColWidth) {
      return `repeat(auto-fit, minmax(${this.minColWidth}, 1fr))`;
    }

    return `repeat(${this.cols}, 1fr)`;
  }

  private resolveRowHeight(): string {
    if (this.rowHeight === 'fit') {
      return '1fr';
    }

    if (this.rowHeight === 'auto') {
      return 'auto';
    }

    return this.rowHeight;
  }
}
